import { render } from "./DeleteElementIcon.vue?vue&type=template&id=3a1b6b0e&scoped=true&ts=true"
import script from "./DeleteElementIcon.vue?vue&type=script&lang=ts"
export * from "./DeleteElementIcon.vue?vue&type=script&lang=ts"

import "./DeleteElementIcon.vue?vue&type=style&index=0&id=3a1b6b0e&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1b6b0e"]])

export default __exports__